import { render } from "./GameCreator.vue?vue&type=template&id=93565656"
import script from "./GameCreator.vue?vue&type=script&lang=ts"
export * from "./GameCreator.vue?vue&type=script&lang=ts"
script.render = render

export default script